/**
 * Lobby links: `?room=<name>` joins that lobby straight away, so a link copied
 * from the lobby (`shareUrl`) brings friends in. The address bar carries the
 * lobby while we're in one (`withRoom`), so a reload rejoins it too.
 */

/** Longest lobby name (the connect form's limit too). */
export const MAX_ROOM_LENGTH = 64;

/** The lobby a link names, or null for none (blank, or too long to be one). */
export function roomFromUrl(href: string): string | null {
  const room = new URL(href).searchParams.get('room')?.trim();
  return room && room.length <= MAX_ROOM_LENGTH ? room : null;
}

/** The link to send friends: just the page and the lobby, nothing else of ours. */
export function shareUrl(href: string, room: string): string {
  const url = new URL(href);
  url.search = '';
  url.hash = '';
  url.searchParams.set('room', room);
  return url.toString();
}

/** `href` naming `room` (null: none), other parameters (`?perf=1`) kept. */
export function withRoom(href: string, room: string | null): string {
  const url = new URL(href);
  if (room === null) url.searchParams.delete('room');
  else url.searchParams.set('room', room);
  return url.toString();
}
